/* eslint-disable max-len */
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
// eslint-disable-next-line max-len
import { type MobilityApplicationEntrypointContextDataFragment } from '../../../../api/fragments/MobilityApplicationEntrypointContextData';
import { useGetPublicStockQuery } from '../../../../api/queries/getPublicStock';
import PortalLoadingElement from '../../../../components/PortalLoadingElement';
import { usePersistentData } from '../../../../utilities/usePersistData';
import { mobilityJourneyTemporaryKey } from '../helper';
import CarDetailsInner from './CarDetailsInner';
import { useExtraDataContext } from './ExtraDataContext';

export type CarDetailsInnerProps = {
    endpoint: MobilityApplicationEntrypointContextDataFragment;
    isCancel?: boolean;
};

const CarDetails = ({ endpoint, isCancel = false }: CarDetailsInnerProps) => {
    const { stockId } = useParams<{ stockId: string }>();

    const { application } = useExtraDataContext();

    const { getItem } = usePersistentData();
    const mobilityJourneyTemporaryValue = useMemo(() => getItem(mobilityJourneyTemporaryKey), [getItem]);

    const { data, loading } = useGetPublicStockQuery({
        fetchPolicy: 'cache-and-network',
        variables: {
            id: stockId,
            omitApplicationId: application?.versioning.suiteId,
            token: mobilityJourneyTemporaryValue?.token,
        },
    });

    if (loading) {
        return <PortalLoadingElement />;
    }

    if (
        data?.stock?.__typename !== 'MobilityStockInventory' ||
        data.stock.inventory.__typename !== 'MobilityInventory'
    ) {
        return null;
    }

    return <CarDetailsInner endpoint={endpoint} isCancel={isCancel} stock={data.stock} />;
};

export default CarDetails;
